import { render } from "./Product.vue?vue&type=template&id=1c0e7a08&scoped=true"
import script from "./Product.vue?vue&type=script&lang=ts"
export * from "./Product.vue?vue&type=script&lang=ts"

import "./Product.vue?vue&type=style&index=0&id=1c0e7a08&scoped=true&lang=css"
import "./Product.vue?vue&type=style&index=1&id=1c0e7a08&lang=css"
script.render = render
script.__scopeId = "data-v-1c0e7a08"

export default script